import React, { FC, HTMLAttributes, ReactEventHandler } from 'react';

export interface A11yDivProps extends HTMLAttributes<HTMLDivElement> {
  onClick?: ReactEventHandler<HTMLDivElement>;
}

const A11yDiv: FC<A11yDivProps> = ({ style = {}, onClick, ...attrs }) => {
  if (!onClick) return <div style={style} {...attrs} />;

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    const keyCode = event.nativeEvent.code;

    if (keyCode === 'Enter' || keyCode === 'Space') {
      onClick(event);
    }
  };

  return (
    <div
      role="button"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      {...attrs}
      style={{
        cursor: 'pointer',
        ...style,
      }}
    />
  );
};

export default A11yDiv;
